module.exports = __webpack_public_path__ + "static/ngv_homepage_laptop-6ae1e4dee0525401428b3e09282d6053.webp";